import { inject } from '@angular/core';
import { LangService } from '@td/i18n';
import { filter, pipe, skip, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { TowingIncidentService } from './towing-incident.service';
import { patchState, signalStore, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { setError, setLoaded, setLoading, withCallState, withReset } from '@ngrx-toolkit/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { toObservable } from '@angular/core/rxjs-interop';
import { AuthStore } from '../../../../core';
import { type TowingIncident } from './towing-incident.model';

type State = {
  incident: TowingIncident | null;
};

const initialState: State = {
  incident: null,
};

export const TowingIncidentStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCallState(),
  withReset(),
  withProps(({ incident }) => ({
    incident$: toObservable(incident),
  })),
  withMethods((store, api = inject(TowingIncidentService), lang = inject(LangService)) => ({
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap(() =>
          api.load(lang.language()).pipe(
            tapResponse({
              next: (incident) => patchState(store, { incident }, setLoaded()),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit(store, authStore = inject(AuthStore), lang = inject(LangService)) {
      lang.lang$
        .pipe(
          filter(() => !!store.incident()),
          skip(1),
        )
        .subscribe(() => store.load());
      authStore.logout$.subscribe(() => store.resetState());
    },
  }),
);
